import type { CreateBackupServerDto } from "@/services/Backup/interfaces";
import { NonEmptyString } from "@/services/FtpUser/validators/string";

type FormFields = CreateBackupServerDto;

type FieldValidator<T> = (value: T) => string | boolean;

type FieldRules = {
  [name in keyof FormFields]: FieldValidator<FormFields[name]>[];
};

export default class CreateBackupServerForm implements FormFields {
  public serverName: string = "";

  public rules: FieldRules = {
    serverName: [
      NonEmptyString("Name is required!"),
    ],
  };
}
